class MiniSideBar {
	constructor($timeout, $templateCache, NavigationService, LocalStorageService) {
		this.restrict = 'E';
		this.$timeout = $timeout;
		this.link = this.MiniSideBarLink;
		this.$win = angular.element(window);
		this.$templateCache = $templateCache;
		this.template = this.htmlStringTemplate;
		this.NavigationService = NavigationService;
		this.LocalStorageService = LocalStorageService;
	}

	get htmlStringTemplate() {
		const templateString = this.$templateCache.get('templates/flyout-menu/mini-side-bar.html');
		return templateString;
	}

	_changeSideBarHeight() {
		const winHeight = this.$win.width() > 521 ? `${this.$win.height()}px` : '3em';
		const menuMinHeight = `min-height:${winHeight} !important`;
		angular.element('.side-menu-container').attr('style', menuMinHeight);
	}

	MiniSideBarLink(scope, element, attrs) {
		this._changeSideBarHeight();

		this.$win.on('resize', () => {
			this._changeSideBarHeight();
		});

		const $element = angular.element(element);
		angular.element('li,a', $element).each((i, link) => {
			const $link = angular.element(link);
			$link.click((evt) => {
				evt.preventDefault();
				if ($link.attr('title') === 'Financials') {
					angular.element('#sideBarContainer burger-menu').trigger('click');
					this.$timeout(() => {
						const display = angular.element('side-bar ul li.sub-menus ul')[0].style.display;
						const isNotShowing = !display || display === 'none';
						if (isNotShowing) {
							angular.element('side-bar ul li.sub-menus').trigger('click');
						}
					}, 220);
				} else {
					let path = $link.attr('ui-sref');
					if (!path) {
						let $urlElement = $link.closest('[ui-sref]');
						if ($urlElement && $urlElement.length > 0) {
							path = $urlElement.attr('ui-sref');
						} else {
							$urlElement = angular.element('[ui-sref]', $link);
							path = $urlElement.attr('ui-sref');
						}
					}

					if (path) {
						path = path.toLowerCase();
						this.LocalStorageService.save('selectedReportMonth', '');
					}
					scope.$parent.$broadcast('navigate-changed', path);
				}

				this.NavigationService.gotoTop();
			});
		});
	}
}

export default /* @ngInject */ ($timeout, $templateCache, NavigationService, LocalStorageService) =>
	new MiniSideBar($timeout, $templateCache, NavigationService, LocalStorageService);
